"use client"

import type React from "react"
import { useEffect, useState } from "react"
import { useParams, Link } from "react-router-dom"
import { fabricAPI, type Product } from "../services/api"
import { SeoHelmet } from "../components/SeoHelmet"
import LogoLoader from "../components/ui/LogoLoader"
import { DEFAULT_DESCRIPTION } from "../config/seo"
import "./CategoryPage.css"

const FabricPage: React.FC = () => {
  const { id } = useParams<{ id: string }>()
  const [fabric, setFabric] = useState<Product | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const fetchFabric = async () => {
      if (!id) return

      try {
        const response = await fabricAPI.getById(Number.parseInt(id))
        setFabric(response.data)
        setLoading(false)
      } catch (err) {
        setError("Ошибка загрузки ткани")
        setLoading(false)
      }
    }

    fetchFabric()
  }, [id])

  if (loading) {
    return (
      <>
        <SeoHelmet title="Ткань" description={DEFAULT_DESCRIPTION} path={id ? `/fabric/${id}` : "/catalog"} />
        <div className="fabric-page">
          <div className="container">
            <LogoLoader />
          </div>
        </div>
      </>
    )
  }

  if (error || !fabric) {
    return (
      <>
        <SeoHelmet title="Ткань" description={DEFAULT_DESCRIPTION} path={id ? `/fabric/${id}` : "/catalog"} />
        <div className="fabric-page">
          <div className="container">
            <div className="error-state">{error || "Ткань не найдена"}</div>
          </div>
        </div>
      </>
    )
  }

  const desc =
    fabric.description?.trim().slice(0, 300) ||
    `Ткань «${fabric.name}» в коллекции «${fabric.collection.name}». Каталог ТЕКС МОЛЛ.`

  return (
    <>
      <SeoHelmet title={fabric.name} description={desc} path={`/fabric/${id}`} />
      <div className="fabric-page">
        <div className="container reveal">
          <nav className="breadcrumb" style={{ marginBottom: "1rem" }}>
            <Link to="/catalog">Каталог</Link>
            <span className="breadcrumb-separator"> / </span>
            <Link to={`/category/${fabric.collection.id}`}>{fabric.collection.name}</Link>
            <span className="breadcrumb-separator"> / </span>
            <span>{fabric.name}</span>
          </nav>
          <h1 className="fabric-title">{fabric.name}</h1>
          {fabric.description ? <p>{fabric.description}</p> : <p>{DEFAULT_DESCRIPTION}</p>}
          <div style={{ marginTop: "1.5rem", display: "flex", gap: "1rem", flexWrap: "wrap" }}>
            <Link to="/contact" className="btn btn-primary">
              Связаться с нами
            </Link>
            <Link to={`/category/${fabric.collection.id}`} className="btn btn-outline">
              Другие ткани категории
            </Link>
          </div>
        </div>
      </div>
    </>
  )
}

export default FabricPage
